<script setup lang="ts">
import SessionParticipants from '@/views/app/session/_components/toolbar/participants/SessionParticipants.vue';
import SessionRounds from '@/views/app/session/_components/toolbar/rounds/SessionRounds.vue';
import SessionInfo from '@/views/app/session/_components/toolbar/SessionInfo.vue';
import { useFlags } from '@/composables/use-feature-flags.ts';
import { Flags } from '@pokerly/shared-common';
const pook52Flag = useFlags(Flags.POK_54_KEEP_TRACK_OF_PLAYED_ROUNDS);
</script>

<template>
    <div class="flex justify-between items-center">
        <SessionParticipants />
        <SessionInfo />
        <SessionRounds v-if="pook52Flag.enabled" />
    </div>
</template>
